<script>
// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default {
  data() {
    return {
      cont: false,
    };
  },
  mounted() {
    var swiper = new Swiper(this.$refs["mySwiper3"], {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
    });
  },
};
</script>

<template>
  <section id="testimonial" class="testimonial">
    <div class="container">
      <div class="swiper-container mySwiper3" ref="mySwiper3">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/dep2.jpg" alt="" />
              </div>
              <div class="text">
                <h4>“</h4>
                <p>
                  É um prazer imenso em fazer parte do time de Farmacêuticos do
                  Grupo DPSP, pois aqui sempre somos estimulados a aprender algo
                  novo e assumir novos desafios, nos aprimorando
                  profissionalmente para proporcionarmos o melhor atendimento
                  aos nossos(as) clientes.”
                </p>
              </div>
              <span>
                <strong class="primary">Francisca Juliete</strong>
                Filial Pires do Rio 3
              </span>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/dep1.jpg" alt="" />
              </div>
              <div class="text">
                <h4>“</h4>
                <p>
                  Ser Farmacêutico no Grupo DPSP é praticar o cuidado todos os
                  dias, é orientar e fornecer uma variedade de serviços
                  farmacêuticos ao paciente, sua família e comunidade, e tudo
                  isso por meio da ação integrada do Farmacêutico com a equipe
                  de colaboradores.”
                </p>
              </div>
              <span>
                <strong> Melquisedeque Menahem </strong> Filial Paulista IV
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.here-card {
  display: flex;
  padding: 5rem 2rem 2rem 2rem;
  background: #ffffff;
  flex-direction: column;
  box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
  border-radius: 30px;
  border-left: 3rem solid theme-color(secondary);
  min-height: 250px;
  justify-content: center;
  @media all and (max-width: 1400px) {
    min-height: 300px;
  }
  @include media-breakpoint-down(sm) {
    padding: 5rem 1rem 2rem 2rem;
  }
  .img {
    width: 80px;
    height: 80px;
    border-radius: 400px;
    border: 1px solid #f7dd69;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: absolute;
    top: -2rem;
    left: -1rem;
    img {
      height: auto !important;
      width: 100% !important;
      display: block;
      margin: 0 auto;
    }
  }
  .text {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    p {
      font-size: 1.1rem;
      font-family: "Nunito";
    }
    h4 {
      font-weight: bold;
      font-size: 4rem;
      position: absolute;
      top: -2.5rem;
      color: #f7dd69;
      left: -0.7rem;
      font-family: "Nunito-bold" !important;
    }
  }

  @include media-breakpoint-down(md) {
    min-height: 100px;
    flex-direction: column;

    .text {
      width: 100%;
      box-sizing: border-box;
      p {
        font-size: 1.3rem;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    flex-direction: column;
    .text {
      width: 100%;
      box-sizing: border-box;
      p {
        font-size: 1rem;
      }
    }
  }
}

span {
  font-size: 1.1rem;
  line-height: calc(1.1rem * 1.2);
  color: #000;
  strong {
    color: theme-color(secondary) !important;
    display: block;
  }
}

.mySwiper3 {
  width: 110%;
  margin-top: 2rem;
  padding: 2rem 1rem 2rem 1rem;
  margin-bottom: -40px;
  @media screen and (max-width: 1400px) {
    padding: 2rem 1rem 2rem 1rem;
    padding-bottom: 7rem;
  }
  @include media-breakpoint-down(sm) {
    padding: 2rem 0rem 2rem 1rem;
    width: 100%;
    .img {
      width: 70px;
      height: 70px;
      left: -1rem;
    }
    border-width: 2rem;
  }
}

.swiper-wrapper {
  height: auto;
}

.testimonial {
  margin: 6rem 0px;
  h2 {
    color: theme-color(primary);
    text-align: center;
    margin-bottom: 4rem;
  }
  @include media-breakpoint-down(sm) {
    margin: 0rem 0px;
  }
  p {
    font-size: 1.9rem;
    color: #000;
  }

  .swiper-container {
    height: 100%;
  }

  .swiper-slide {
    font-size: 18px;
    background: #fff;
    position: relative;
  }

  .swiper-slide img {
    display: block;
    object-fit: cover;
  }
}
</style>